import { createReducer } from "typesafe-actions";

import DrillDownViewState from "@app/scene/dashboard/types/DrillDownViewState";
import ActivitiesOverdueCardConfiguration from "@app/types/dashboard/cards/activitiesOverdue/ActivitiesOverdueCardConfiguration";
import { DEFAULT_PAGE_SIZE } from "@app/util/consts";
import { createEmptyFilterModel } from "@app/util/filters/utils";

import {
  ActivitiesOverdueCardActions,
  applyActivitiesOverdueDrillDownListViewSettings,
  fetchActivitiesOverdueCardDrillDownData,
  hideActivitiesOverdueDrillDown,
  showActivitiesOverdueDrillDown,
} from "./actions";

export interface ActivitiesOverdueCardState {
  configuration?: ActivitiesOverdueCardConfiguration; // also works as a "visible" trigger, visible if set
  loading?: boolean;
  totalFilteredRecords: number;
  totalRecords: number;
  viewState: DrillDownViewState;
}

export const activitiesOverdueInitialState: ActivitiesOverdueCardState = {
  totalFilteredRecords: 0,
  totalRecords: 0,
  viewState: {
    columns: [],
    filter: createEmptyFilterModel(),
    range: { endRow: DEFAULT_PAGE_SIZE, startRow: 0 },
    sort: [],
  },
};

const activitiesOverdueState = createReducer<
  ActivitiesOverdueCardState,
  ActivitiesOverdueCardActions
>(activitiesOverdueInitialState)
  .handleAction(showActivitiesOverdueDrillDown.request, (state, { payload }) => ({
    ...state,
    configuration: payload.configuration,
  }))
  .handleAction(showActivitiesOverdueDrillDown.success, (state, { payload }) => ({
    ...state,
    viewState: payload.viewState,
  }))
  .handleAction(hideActivitiesOverdueDrillDown, (state) => ({ ...state, configuration: undefined }))
  .handleAction(fetchActivitiesOverdueCardDrillDownData.request, (state) => ({
    ...state,
    loading: true,
  }))
  .handleAction(fetchActivitiesOverdueCardDrillDownData.success, (state, { payload }) => ({
    ...state,
    loading: false,
    totalFilteredRecords: payload.totalFilteredRecords,
    totalRecords: payload.totalRecords,
  }))
  .handleAction(fetchActivitiesOverdueCardDrillDownData.failure, (state) => ({
    ...state,
    loading: false,
  }))
  .handleAction(applyActivitiesOverdueDrillDownListViewSettings, (state, { payload }) => ({
    ...state,
    viewState: {
      ...state.viewState,
      columns: payload.columns ?? state.viewState.columns,
      filter: payload.filter ?? state.viewState.filter,
      range: payload.range ?? state.viewState.range,
      sort: payload.sort ?? state.viewState.sort,
    },
  }));

export default activitiesOverdueState;
